import { PayRequestPayload } from "checkout-query-client/api/types";
import {
  getAcceptedMandates,
  getDeviceFingerprintSessionId,
} from "checkout-query-client/utils/helpers";

import { valueEncrypt } from "encrypt-value/encrypt";

import {
  BrowserInfo,
  EncryptedPayByBank,
  PayRequest,
  PaymentMethod,
  PaymentMethod_Type,
} from "frontend-client";

export const buildPayByBankPayload = async (
  payload: PayRequestPayload
): Promise<PayRequest> => {
  const { formFields, merchantSettings, payByBankRequestId, orderDigest } =
    payload;
  const request = new PayRequest();
  const browserInfo = new BrowserInfo();
  const paymentMethod = new PaymentMethod();
  const encryptedPayByBank = new EncryptedPayByBank();

  paymentMethod.type = PaymentMethod_Type.PAY_BY_BANK;

  if (!payByBankRequestId) {
    // if loaded outside of HTTPS this will blow up, wrap in a try/catch
    try {
      // initial pay by bank call
      const encrypted = await valueEncrypt({
        value: "1234567890", // Dummy value.  A value is required -- it is unused upstream to generate a consentUrl.
        key: merchantSettings?.encryptionKey ?? "",
      });
      encryptedPayByBank.tokenizedAccountNumber = encrypted.encryptedData ?? "";
    } catch (e) {
      encryptedPayByBank.tokenizedAccountNumber = "";
    }
  } else {
    // regular pay by bank pay call
    encryptedPayByBank.payByBankRequestId = payByBankRequestId;
  }

  encryptedPayByBank.encryptionKeyId = merchantSettings?.encryptionKeyId ?? "";

  paymentMethod.payByBank = encryptedPayByBank;
  const acceptedMandates = getAcceptedMandates(formFields);
  request.paymentMethod = paymentMethod;
  request.acceptedMandates = acceptedMandates;

  // 3ds TODO: tie this in
  request.scaChallengeWindowSize = 4;

  const date = new Date();

  browserInfo.acceptHeader = "text/html;charset=UTF-8";
  browserInfo.language = window.navigator.language || "";
  browserInfo.colorDepth = window.screen.colorDepth || 0;
  browserInfo.screenHeight = window.screen.height || 0;
  browserInfo.screenWidth = window.screen.width || 0;
  browserInfo.timezoneOffset = date.getTimezoneOffset() || 0;
  request.browserInfo = browserInfo;
  request.orderDigest = orderDigest ?? "";
  request.deviceFingerprintSessionId = getDeviceFingerprintSessionId();

  return request;
};
